import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { Close } from './icons';
import Apps from './apps';
import Dialog from './dialog';
var ConsentModal = /*#__PURE__*/function (_React$Component) {
  function ConsentModal() {
    _classCallCheck(this, ConsentModal);
    return _callSuper(this, ConsentModal, arguments);
  }
  _inherits(ConsentModal, _React$Component);
  return _createClass(ConsentModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        onHideRequest = _this$props.onHideRequest,
        onSaveRequest = _this$props.onSaveRequest,
        config = _this$props.config,
        manager = _this$props.manager,
        t = _this$props.t,
        ns = _this$props.ns;
      var isAlert = config.mustConsent && (!manager.confirmed || manager.changed);
      return /*#__PURE__*/React.createElement(Dialog, {
        isOpen: isOpen,
        aria: {
          'labelledby': 'orejime-modal-title'
        },
        portalClassName: ns('ModalPortal'),
        overlayClassName: ns('ModalOverlay'),
        className: ns('ModalWrapper'),
        config: config,
        onRequestClose: onHideRequest,
        role: isAlert ? 'alertdialog' : 'dialog'
      }, /*#__PURE__*/React.createElement("div", {
        className: ns('Modal')
      }, /*#__PURE__*/React.createElement("div", {
        className: ns('Modal-header')
      }, !isAlert && /*#__PURE__*/React.createElement("button", {
        title: t(['close']),
        className: ns('Modal-closeButton'),
        type: "button",
        onClick: onHideRequest
      }, /*#__PURE__*/React.createElement(Close, {
        t: t,
        ns: ns
      })), /*#__PURE__*/React.createElement("h1", {
        className: ns('Modal-title'),
        id: "orejime-modal-title"
      }, t(['consentModal', 'title'])), /*#__PURE__*/React.createElement("p", {
        className: ns('Modal-description')
      }, manager.changed && (config.mustConsent || config.noNotice) && /*#__PURE__*/React.createElement("p", {
        className: ns('Modal-description')
      }, /*#__PURE__*/React.createElement("strong", {
        className: ns('Modal-changes')
      }, t(['consentNotice', 'changeDescription']))), /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: t(['consentModal', 'description'])
        }
      }), "\xA0", t(['consentModal', 'privacyPolicy', 'text'], {
        privacyPolicy: /*#__PURE__*/React.createElement("a", {
          key: "privacyPolicyLink",
          className: ns('Modal-privacyPolicyLink'),
          onClick: function onClick(e) {
            onHideRequest();
          },
          href: config.privacyPolicy
        }, t(['consentModal', 'privacyPolicy', 'name']))
      }))), /*#__PURE__*/React.createElement("form", {
        className: ns('Modal-form')
      }, /*#__PURE__*/React.createElement("div", {
        className: ns('Modal-body')
      }, /*#__PURE__*/React.createElement(Apps, {
        t: t,
        ns: ns,
        config: config,
        manager: manager
      })), /*#__PURE__*/React.createElement("div", {
        className: ns('Modal-footer')
      }, /*#__PURE__*/React.createElement("button", {
        className: ns('Button Button--save Modal-saveButton'),
        onClick: onSaveRequest,
        title: t(['saveData'])
      }, t(['save'])), /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        className: ns('Modal-poweredByLink'),
        href: config.poweredBy || 'https://orejime.empreintedigitale.fr',
        title: "".concat(t(['poweredBy']), " (").concat(t(['newWindow']), ")")
      }, t(['poweredBy']))))));
    }
  }]);
}(React.Component);
export { ConsentModal as default };